import { KosmosReportDto, PdfStyleDto } from 'models/dtoTypes';
import { getKosmosReportApi } from 'services';

export const GetCompanyKosmosReportById = async (
  companyId: string,
  organisationId?: string,
  reportSnapshotId?: string,
): Promise<KosmosReportDto> => {
  const client = await getKosmosReportApi();
  const response = await client.getCompanyKosmosReportById(companyId, organisationId, reportSnapshotId);
  return response?.data;
};

export const GetSgReportById = async (
  companyId: string,
  organisationId?: string,
): Promise<KosmosReportDto[]> => {
  const client = await getKosmosReportApi();
  const response = await client.getSelfGovernanceReportById(companyId, organisationId);
  return response?.data;
};

export const DownloadKosmosPdfReportByCompanyId = async (
  companyId: string,
  organisationId?: string,
  pdfStyleType?: PdfStyleDto,
) => {
  const client = await getKosmosReportApi();
  return await client.getCompanyPdfKosmosReportById(
    companyId,
    organisationId,
    false, // debug will return html
    pdfStyleType,
  );
};

export const GetCompanyCombinedPdfKosmosReportById = async (
  companyId: string,
  organisationId?: string,
) => {
  const client = await getKosmosReportApi();
  return await client.getCompanyCombinedPdfKosmosReportById(companyId, organisationId);
};
